var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 292201",
    cx: 11.9395,
    cy: 6.43961,
    rx: 9.42,
    ry: 3.84,
    stroke: "currentColor",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 292202",
    d: "M3.26531 10.38C2.78516 10.8408 2.51953 11.3478 2.51953 11.88C2.51953 14.0008 6.73701 15.72 11.9395 15.72C17.1421 15.72 21.3595 14.0008 21.3595 11.88C21.3595 11.3478 21.0939 10.8408 20.6138 10.38",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 292203",
    d: "M3.26531 16C2.78516 16.4608 2.51953 16.9678 2.51953 17.5C2.51953 19.6208 6.73701 21.34 11.9395 21.34C17.1421 21.34 21.3595 19.6208 21.3595 17.5C21.3595 16.9678 21.0939 16.4608 20.6138 16",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXp);
export default __webpack_public_path__ + "static/media/xp.ac11a962c9f929858fd4e72573a4b591.svg";
export { ForwardRef as ReactComponent };